import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import "ag-grid-enterprise";
import { Select } from "antd";

const { Option } = Select;

export const SearchSelect = forwardRef((props, ref) => {
  const [optionValue, setOptionValue] = useState(props.value);
  const [editing, setEditing] = useState(true);
  const [productList, setProductList] = useState([]);
  const [productNameList, setProductNameList] = useState([]);
  const refContainer = useRef(null);
  const productSelect = useRef(null);

  useEffect(() => {
    focus();
    setProductList(props.colDef.selectValues);
    if (props.value) {
      let tempSelectValues = [...props.colDef.selectValues];
      tempSelectValues.push(props.value);
      setProductNameList(tempSelectValues);
    } else {
      setProductNameList(props.colDef.selectValues);
    }
  }, []);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return optionValue;
      },
      isPopup() {
        return true;
      },
    };
  });

  useEffect(() => {
    if (!editing) {
      props.api.stopEditing();
    }
  }, [editing]);

  const focus = () => {
    window.setTimeout(() => {
      if (refContainer.current) {
        refContainer.current.focus();
      }
      if (productSelect.current) {
        productSelect.current.focus();
      }
    });
  };

  const setValues = () => {
    return productNameList.map((val) => <Option key={val}>{val}</Option>);
  };

  const handleSelect = (val) => {
    setOptionValue(val);
    setEditing(false);
  };

  const handleSearch = (value) => {
    const filtered = productList.filter((item) =>
      item.toLowerCase().includes((value || "").toLowerCase())
    );
    setProductNameList(filtered);
  };

  return (
    <div
      ref={refContainer}
      tabIndex={1} // important - without this the key presses wont be caught
    >
      <Select
        showSearch
        showArrow={true}
        allowClear
        placeholder="Enter product name"
        style={{ width: 200 }}
        onSelect={handleSelect}
        onSearch={handleSearch}
        defaultValue={props.value}
        ref={productSelect}
        dropdownClassName="ag-custom-component-popup"
      >
        {setValues()}
      </Select>
    </div>
  );
});
